type NotificationBadgeState = {
    activeSpaceId?: string | number | null
    numNoti: number
    spaceNotiCounts?: Record<string, number>
}

const notificationBadgeEventVersions = new Map<string, number>()

function notificationBadgeSpaceKey(spaceId: string | number | null | undefined) {
    return String(spaceId)
}

export function markSpaceNotificationBadgeEvent(spaceId: string | number | null | undefined) {
    const key = notificationBadgeSpaceKey(spaceId)
    const version = (notificationBadgeEventVersions.get(key) || 0) + 1
    notificationBadgeEventVersions.set(key, version)
    return version
}

export function getSpaceNotificationBadgeEventVersion(spaceId: string | number | null | undefined) {
    return notificationBadgeEventVersions.get(notificationBadgeSpaceKey(spaceId)) || 0
}

// When each space's notifications were last cleared on the server (the
// notifications page loaded with clear=true). A count request that started
// before then can read rows the clear has since marked seen, so its answer
// must not bring a cleared badge back.
const notificationClearTimes = new Map<string, number>()

export function markSpaceNotificationsCleared(spaceId: string | number | null | undefined) {
    notificationClearTimes.set(notificationBadgeSpaceKey(spaceId), Date.now())
}

export function isNotificationCountStale(
    spaceId: string | number | null | undefined,
    requestedAt: number,
) {
    return requestedAt < (notificationClearTimes.get(notificationBadgeSpaceKey(spaceId)) || 0)
}

export function consumeSpaceNotificationBadge(
    state: NotificationBadgeState,
    viewedSpaceId: string | number | null | undefined,
) {
    if (String(state.activeSpaceId) === String(viewedSpaceId)) state.numNoti = 0
    if (viewedSpaceId != null) {
        state.spaceNotiCounts = { ...state.spaceNotiCounts, [viewedSpaceId]: 0 }
    }
}

export function consumeSpaceNotificationBadgeIfVersionMatches(
    state: NotificationBadgeState,
    viewedSpaceId: string | number | null | undefined,
    expectedVersion: number,
): void {
    if (getSpaceNotificationBadgeEventVersion(viewedSpaceId) !== expectedVersion) return

    consumeSpaceNotificationBadge(state, viewedSpaceId)
}
